import React, { useEffect } from 'react';
import AppRoutes from '@/router/appRoutes';
import { Footer } from '@/components/general/Footer';
import { Header } from '@/components/general/Header';
import { SearchComponent } from '@/components/general/SearchComponent';
import { useDispatch } from 'react-redux';
import { setLocation } from '@/redux/actions/locationActions';
import { useLocation } from 'react-router-dom';
import { setLenguageData } from '@/redux/actions/lenguageDataActions';
import { setCurrency } from '@/redux/actions/currencyActions';
import { useSelector } from 'react-redux';
import { useFetchIpService } from '@/services/locationService';
import { syncUserFromToken } from '@/services/userService';
import { setUser } from '@/redux/actions/userActions';
import { isEnglishSpeakingCountry, isMexico } from '@/helpers/locationHelpers';
import {
  routesWithoutHeaderOptions,
  routesWithoutSeekerOptions,
} from '@/helpers/pathnameHelpers';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import '@/App.css';
import '@/style/main.scss';

dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const localUser = localStorage.getItem('user');

    if (localUser) {
      try {
        const parsedUser = JSON.parse(localUser);
        dispatch(setUser(parsedUser));
        console.log(' Usuario restaurado desde localStorage:', parsedUser);
      } catch (error) {
        console.error(' Error leyendo user desde localStorage:', error);
        localStorage.removeItem('user');
      }
    }
  }, [dispatch]);

  /* useEffect(() => {
    const runSync = async () => {
      const synced = await syncUserFromToken(dispatch);

      if (synced) {
        console.log('🟢 Sync de usuario completado');
      }
    };

    runSync();
  }, [dispatch]); */

  const { data, isLoading } = useFetchIpService();
  const location = useLocation();
  const hideFooter = routesWithoutHeaderOptions?.includes(location.pathname);
  const hideSeeker = routesWithoutSeekerOptions?.some(route =>
    location.pathname.startsWith(route),
  );
  const languageIsFromButton = useSelector(state => state.lenguage?.isButton);
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  if (isLoading) {
    return <></>;
  } else {
    if (data) {
      if (!languageIsFromButton) {
        dispatch(setLocation(data));
        isEnglishSpeakingCountry(data)
          ? dispatch(setLenguageData({ lang: 'EN', isButton: false }))
          : dispatch(setLenguageData({ lang: 'ES', isButton: false }));
        isMexico(data)
          ? dispatch(setCurrency({ currency: 'MXN', isButton: false }))
          : dispatch(setCurrency({ currency: 'USD', isButton: false }));
      }
      return (
        <div>
          <GoogleOAuthProvider
            clientId="722633985733-f75idvl4lsof3mfus8spsoaq33ao9qnb.apps.googleusercontent.com"
            language="en"
          >
            <Elements stripe={stripePromise}>
              {/*!hideSeeker && <SearchComponent />*/}
              <Header />
              <AppRoutes />
              {!hideFooter && <Footer />}
            </Elements>
          </GoogleOAuthProvider>
        </div>
      );
    } else {
      return <></>;
    }
  }
}

export default App;
